import { render, staticRenderFns } from "./VTabs.vue?vue&type=template&id=042ee536&"
import script from "./VTabs.vue?vue&type=script&lang=js&"
export * from "./VTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042ee536')) {
      api.createRecord('042ee536', component.options)
    } else {
      api.reload('042ee536', component.options)
    }
    module.hot.accept("./VTabs.vue?vue&type=template&id=042ee536&", function () {
      api.rerender('042ee536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/VTabs.vue"
export default component.exports